var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$store.getters.user.id == "H2kEJMbkyxUhcAfKH1jcMeDOn442" ||
    this.$store.getters.user.id == "b8Yc6Iz0ktV6ofVC1lHgCJ3EQCn1" ||
    this.$store.getters.user.id == "L8ZKmImHhpbKQEbNVVTzzwj4pls1" ||
    this.$store.getters.user.id == "OkvqiVsL6cc4hdaOL97QWU7gCEM2" ||
    this.$store.getters.user.id == "QBRXqktYi0QigFboM92crKAONKn1"
    ? _c(
        "v-container",
        [
          _c("span", { staticClass: "headline" }, [
            _vm._v("Edit Artist Settings")
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c("span", [_vm._v("Name:")]),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: _vm.artistName, solo: "" },
                model: {
                  value: _vm.artist_obj.name,
                  callback: function($$v) {
                    _vm.$set(_vm.artist_obj, "name", $$v)
                  },
                  expression: "artist_obj.name"
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Email:")]),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: {
                  rules: _vm.emailRules,
                  label: _vm.artistEmail,
                  solo: ""
                },
                model: {
                  value: _vm.artist_obj.email,
                  callback: function($$v) {
                    _vm.$set(_vm.artist_obj, "email", $$v)
                  },
                  expression: "artist_obj.email"
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Free Credits:")]),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: _vm.artistFree, solo: "" },
                model: {
                  value: _vm.artist_obj.free_credits,
                  callback: function($$v) {
                    _vm.$set(_vm.artist_obj, "free_credits", $$v)
                  },
                  expression: "artist_obj.free_credits"
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Paid Credits:")]),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: _vm.artistPaid, solo: "" },
                model: {
                  value: _vm.artist_obj.credits,
                  callback: function($$v) {
                    _vm.$set(_vm.artist_obj, "credits", $$v)
                  },
                  expression: "artist_obj.credits"
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Instagram:")]),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: _vm.artistInsta, solo: "" },
                model: {
                  value: _vm.artist_obj.instagram,
                  callback: function($$v) {
                    _vm.$set(_vm.artist_obj, "instagram", $$v)
                  },
                  expression: "artist_obj.instagram"
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Photo URL:")]),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: _vm.artistPhoto, solo: "" },
                model: {
                  value: _vm.artist_obj.photoUrl,
                  callback: function($$v) {
                    _vm.$set(_vm.artist_obj, "photoUrl", $$v)
                  },
                  expression: "artist_obj.photoUrl"
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Role:")]),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: _vm.artistRole, solo: "" },
                model: {
                  value: _vm.artist_obj.role,
                  callback: function($$v) {
                    _vm.$set(_vm.artist_obj, "role", $$v)
                  },
                  expression: "artist_obj.role"
                }
              }),
              _vm._v(" "),
              _c("v-alert"),
              _vm._v(" "),
              _c(
                "v-alert",
                { attrs: { value: _vm.successAlert, type: "success" } },
                [_vm._v("\n      Settings changed Successfully.\n    ")]
              ),
              _vm._v(" "),
              _c(
                "v-alert",
                { attrs: { value: _vm.failureAlert, type: "error" } },
                [_vm._v("\n      Settings changes failed.\n    ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { primary: "", disabled: !_vm.valid },
                  on: {
                    click: function($event) {
                      _vm.submitData()
                    }
                  }
                },
                [_vm._v("Submit Changes")]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e7ef3fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e7ef3fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/artist_settings.vue
// module id = null
// module chunks = 